import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const envVariables = createEnv({
  clientPrefix: "VITE_",
  client: {
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_ENVIRONMENT: z.union([
      z.literal("local"),
      z.literal("development"),
      z.literal("staging"),
      z.literal("production"),
    ]),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
